import script from "./ProjectContributionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectContributionsList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectContributionsList.vue?vue&type=style&index=0&id=384b4301&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-384b4301"]])

export default __exports__